import { SITE } from "../constants/site";

// Author pages copy, shared by the SEO renderer (server) and the pages (client) so crawlers and
// people read the same headings.

export const AUTHOR_COPY = {
  listEyebrow: "Author",
  listTitle: `Author ${SITE.name}`,
  listDescription:
    "Kenali para praktisi di balik kelas, ebook, dan workflow automation & AI berbahasa Indonesia, lalu lihat semua karya mereka.",
  productCount: (count: number) => `${count.toLocaleString("id-ID")} produk`,
  productsTitle: (name: string) => `Kelas & produk dari ${name}`,
  pageTitle: (name: string) => `${name}, Author di ${SITE.name}`,
  pageDescription: (author: { name: string; headline: string | null; bio: string | null }) =>
    author.bio ??
    `${author.name}${author.headline ? ` — ${author.headline}` : ""}. Lihat semua kelas, ebook, dan workflow dari ${author.name} di ${SITE.name}.`,
} as const;
